import { all, call, put, takeLatest } from 'redux-saga/effects';
import { encryptData } from '../../_common/enode-decode';
import {
	getGoldStockReportFailure,
	getGoldStockReportResponseChanged,
	getGoldStockReportSuccess,
} from './gold-stock-report.action';
import GoldStockActionTypes from './gold-stock-report.types';
import AlertManager from '../../../utils/alertManager';
import { GoldStockReportGet } from './gold-stock-report.service';

/** ********************* START GET GOLD STOCK REPORT DETAILS ******************** */

export function* getGoldStockReport({ payload }: any) {
	try {
		const key = 'GoldStockReportKey';
		const {
			companyID,
			userID,
			userName,
			userAccessBranchID,
			branchID,
			databaseName,
			requestStartDate,
			requestEndDate,
			userLevel,
			limit,
			officerID,
			funderID,
			centerID,
		} = payload;

		const jsonData = {
			CompanyID: companyID,
			UserID: userID,
			UserRole: userName,
			Location: userAccessBranchID,
			BranchID: branchID,
			DatabaseName: databaseName,
			FromDate: requestStartDate,
			ToDate: requestEndDate,
			UserLevel: userLevel,
			OfficerID: officerID,
			CenterID: centerID,
			FunderID: funderID,
			Limit: limit,
		};

		const encodeData = encryptData(jsonData, key);

		// @ts-ignore
		const responseData = yield call(GoldStockReportGet, encodeData);

		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getGoldStockReportFailure(responseData.data));
		} else {
			yield put(getGoldStockReportSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getGoldStockReportFailure(error));
	}
}

export function* resetGetGoldStockReportResponse() {
	yield put(getGoldStockReportResponseChanged());
}

export function* onGetGoldStockReport() {
	yield takeLatest(GoldStockActionTypes.GET_GOLD_STOCK_REPORT_START, getGoldStockReport);
}

export function* onGetGoldStockReportResponseReset() {
	yield takeLatest(
		GoldStockActionTypes.GET_GOLD_STOCK_REPORT_RESPONSE_RESET,
		resetGetGoldStockReportResponse,
	);
}

/** ********************* END GET GOLD STOCK REPORT DETAILS ******************** */

// Export all sagas for root saga
export function* goldStockSaga() {
	yield all([call(onGetGoldStockReport), call(onGetGoldStockReportResponseReset)]);
}
